import { Button } from '@/_components/ui'

interface ConfirmationActionsProps {
  canConfirm: boolean
  isPending: boolean
  onReject: () => void
  onConfirm: () => void
}

export const ConfirmationActions = ({
  canConfirm,
  isPending,
  onReject,
  onConfirm,
}: ConfirmationActionsProps) => (
  <div className="flex flex-wrap items-center justify-end gap-3 py-3">
    <div className="flex gap-3">
      <Button
        type="button"
        variant="gray"
        className="font-sans font-semibold"
        onClick={onReject}
        disabled={isPending}
      >
        Rejeitar
      </Button>
      <Button
        type="button"
        className="font-sans font-semibold disabled:bg-brand-grayscale-4 disabled:text-brand-grayscale-7 disabled:opacity-100"
        disabled={!canConfirm || isPending}
        isLoading={isPending}
        onClick={onConfirm}
      >
        Confirmar dados
      </Button>
    </div>
  </div>
)
